import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';


import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzPipesModule } from 'ng-zorro-antd/pipes';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { OperationDeleteComponent } from './components/operation-delete/operation-delete.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { OperationsComponent } from './components/operations/operations.component';
import { OperationDetailListComponent } from './components/operation-detail-list/operation-detail-list.component';
import { OperationDetailComponent } from './components/operation-detail/operation-detail.component';

export const operationRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./components/operations/operations.component').then(m => m.OperationsComponent)
  },
  {
    path: 'list',
    loadComponent: () => import('./components/operation-detail-list/operation-detail-list.component').then(m => m.OperationDetailListComponent)
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(operationRoutes),
    NzGridModule,
    NzFormModule,
    ReactiveFormsModule,
    NzButtonModule,
    NzIconModule,
    NzTableModule,
    TranslateModule,
    NzPopconfirmModule,
    NzTagModule,
    NzDescriptionsModule,
    NzCardModule,
    NzTabsModule,
    NzListModule,
    NzDividerModule,
    NzEmptyModule,
    NzPipesModule,
    NzDatePickerModule,
    NzPopoverModule,
    FormsModule,
    NzSpaceModule,
    NgxPermissionsModule,
    NzCheckboxModule,
    NzModalModule,
    NzTypographyModule,
    NzAlertModule,
    OperationsComponent,
    OperationDetailComponent,
    OperationDetailListComponent,
    OperationDeleteComponent
  ],
  exports: [
    OperationsComponent,
    OperationDetailComponent,
    OperationDetailListComponent
  ]
})
export class OperationModule {
}
